import { IO365ShellShim } from '@1js/suiteux-shell-react';

type UseO365ShellShim = () => IO365ShellShim | undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useO365ShellShim: UseO365ShellShim = () => (window as any).O365Shell;
